export const queryKeys = {
	thumbnails: {
		all: ['thumbnails'] as const,
		byImage: (caseId: string, imageId: string) => ['thumbnails', caseId, imageId] as const,
		detail: (caseId: string, imageId: string, width: number, height: number) =>
			['thumbnails', caseId, imageId, width, height] as const,
	},
	logo: {
		all: ['logo'] as const,
		detail: (caseId: string) => ['logo', caseId] as const,
	},
};
